export const queControlConfig = {
  CONTROL_TEXT: 1,
  CONTROL_LIST: 2,
  CONTROL_TWO_CHOICES: 3,
  CONTROL_MULTIPLE_CHOICES: 4,
  CONTROL_EMAIL: 5,
  CONTROL_TERMS_AND_CONDITIONS: 6,
  CONTROL_NUMBER: 7,
  CONTROL_DATE: 8,
  CONTROL_TIME: 9,
  CONTROL_IMAGE: 10,
  CONTROL_PHOTO: 11,
  CONTROL_RATING: 12,
  CONTROL_QR_AND_BARCODE_READER: 13,
  CONTROL_SIGNATURE: 14,
  CONTROL_START_SCREEN: 17,
  CONTROL_END_SCREEN: 18,
  CONTROL_AUDIO: 19,
  CONTROL_VIDEO: 20,
  CONTROL_DYNAMIC: 21
};

export const queTypeConfig = {
  TYPE_INPUT: 1,
  TYPE_DISPLAY: 2,
  TYPE_LIST: 3,
  TYPE_YES_NO: 4,
  TYPE_MULTIPLE_TEXT: 5,
  TYPE_EMAIL: 6,
  TYPE_TERMS_AND_CONDITIONS: 7,
  TYPE_CURRENCY: 8,
  TYPE_DATE: 9,
  TYPE_12_HOURS: 10,
  TYPE_TRUE_FALSE: 11,
  TYPE_OTHER: 12,
  TYPE_MULTIPLE_IMAGE: 13,
  TYPE_NUMBER: 14,
  TYPE_TELEPHONE: 15,
  TYPE_24_HOURS: 16,
  TYPE_IMAGE: 17,
  TYPE_CAMERA: 18,
  TYPE_SATISFACTION: 19,
  TYPE_STAR: 20,
  TYPE_QR_AND_BARCODE_READER: 21,
  TYPE_SIGNATURE: 22,
  TYPE_START_SCREEN_TEXT: 23,
  TYPE_START_SCREEN_IMAGE: 24,
  TYPE_END_SCREEN_TEXT: 25,
  TYPE_END_SCREEN_IMAGE: 26,
  TYPE_VIDEO: 27,
  TYPE_AUDIO: 28,
  TYPE_DYNAMIC_LIST: 29,
};

export const queValidationConfig = {
  VALIDATION_MANDATORY_QUE: 1,
  VALIDATION_MIN_CHAR: 2,
  VALIDATION_MAX_CHAR: 3,
  VALIDATION_MIN_NUM: 4,
  VALIDATION_MAX_NUM: 5,
  VALIDATION_SINGLE_LINE: 6,
  VALIDATION_PARAGRAPH: 8,
  VALIDATION_SERIAL_NUM: 9,
  VALIDATION_ALLOWED_CHAR: 10,
  VALIDATION_SUBTITLE: 11,
  VALIDATION_TERMS_AND_CONDITIONS: 12,
  VALIDATION_ALLOW_OTHER_ANS: 13,
  VALIDATION_TEXT: 14,
  VALIDATION_IMAGE: 15,
  VALIDATION_YES_NO: 16,
  VALIDATION_TRUE_FALSE: 17,
  VALIDATION_OTHER_CHOICES: 18,
  VALIDATION_MULTIPLE_SINGLE_ANS: 19,
  VALIDATION_ALLOW_MORE_THAN_ONE_ANS: 20,
  VALIDATION_SHOW_ANS_LABEL: 21,
  VALIDATION_EMAIL_SURVEY_RESULTS: 22,
  VALIDATION_NUM: 23,
  VALIDATION_TELEPHONE: 24,
  VALIDATION_CURRENCY: 25,
  VALIDATION_ALLOWED_TELEPHONE_CHAR: 26,
  VALIDATION_ALLOWED_CURRENCY_CHAR: 27,
  VALIDATION_ALLOW_DECIMAL_NUM: 28,
  // VALIDATION_DATE_FORMAT: 29, (Double entries in db for this)
  VALIDATION_MIN_DATE: 30,
  VALIDATION_MAX_DATE: 31,
  VALIDATION_MIN_TIME: 32,
  VALIDATION_MAX_TIME: 33,
  VALIDATION_FLOW: 34,
  VALIDATION_SHOW_TITLE: 35,
  VALIDATION_CAMERA: 36,
  VALIDATION_RATING_TYPE: 37,
  VALIDATION_STAR_RATING: 38,
  VALIDATION_FACE_RATING: 39,
  VALIDATION_FIRST_CHOICE: 40,
  VALIDATION_SECOND_CHOICE: 41,
  VALIDATION_DATE_FORMAT: 42,
  VALIDATION_ACCESS_TO_GALLERY: 43,
  VALIDATION_TITLE: 44,
  VALIDATION_BUTTON_TEXT: 45,
  VALIDATION_TIMEOUT: 46,
  VALIDATION_BUTTON: 47,
  VALIDATION_TIMEOUT_IN_SEC: 48,
  VALIDATION_ADDRESS_QUE: 49,
  VALIDATION_DRAW_ON_PHOTO: 50,
  VALIDATION_ACCESS_TO_MEDIA_GALLERY: 51,
  VALIDATION_CONTRACT_ID: 52,
  VALIDATION_SERVICE_IDS: 53,

};
export const constantCommonConfig = {
  SURVEY_PUBLISHED: 1,
  SURVEY_DRAFT: 5
};

export const permissions = {
  VIEWDRAFTSURVEYS : 40
};

export const frontHostName = location.protocol + "//" + location.hostname; //#local
// export const frontHostName = location.protocol + '//' + location.host; //#live

export const redirectUrl = location.protocol + "//" + location.host; //#local+#live
export const constantUserPermissions = {
  EDIT_SKIP_LOGIC_RULE: 43
};

//export const signupUrl = location.protocol + "//" + location.hostname + '/tapapp/tapappcloud/signup'; //#local
// export const signupUrl = location.protocol + '//my.hispecservices.com/my/signup'; //#live
export const signupUrl = location.protocol + '//my.tapapp.work/my/signup'; //#live - new domain change

export const defaultWhiteLabel = 'default';

export const encrypted_key = '5267556B58703273357638792F413F4428472B4B6250655368566D5971337436';

export const encrypted_iv = 'abcdef9876543210abcdef9876543210';

export const currentVersion = 'V3.2021.323.1';

export const recaptchaSiteKey = '6LdlVo4sAAAAAEvIJZA9nVGSE70VoFV3FQaDJUFz';

// Set to false to hide login reCAPTCHA and skip verification (must match API RECAPTCHA_ENABLED)
export const recaptchaEnabled = false;

export const searchLastResponseDate = "Last service performed:"

export const formsettings = "formsettings/"

export const mapboxAccessToken = 'pk.eyJ1IjoiZ2ludGF1dGFzLW1vcmt1bmFzIiwiYSI6ImNqcmFkeTBoYzBxcXQ0M252ZzhkYnhqcTMifQ.C2s_bxwQTDf7Nd2WJ630tw';

export const userTypeConfig = {
  TYPE_ACCOUNT_ADMIN: 1,
  TYPE_NORMAL_USER: 2,
  TYPE_PHONE_USER: 3,
  TYPE_BOTH: 4,
  TYPE_SUPERADMIN : 5,
};